<template lang="pug">
    .uploader
        .header
          IQToolMiddlePaneHeader(:header="$t(`${baseTranslationPath}.header`)"
            :title="$t(`${baseTranslationPath}.title`)"
            @goToListPage="navigateAway()")
          .button-container
            aiq-button(size="small" class="btn" @click="navigateAway()") {{ $t(`global.cancel`) }}
            aiq-button(type="primary" size="small" class="btn" @click="navigateAway()") {{ $t(`global.save`) }}
        EditArea.edit-area
          template(#content)
            .file-upload
              .upload-info {{ $t(`${baseTranslationPath}.upload_your_document`) }}
              FileUploader(
                  :fileList="fileList",
                  @getFileList="getFileList",
                  upload_tips="(PDF - MAX 25MB)",
                  acceptedFileType="application/pdf"
                  :supported_files="['application/pdf']"
              )
              .tip-area
                .tip-header
                  fa-icon(icon="fa-solid fa-lightbulb-on" class="tip-icon")
                  span {{ $t(`${baseTranslationPath}.tips`) }}
                .tip-content(v-html="getTipContent")
</template>
<script>
import IQToolMiddlePaneHeader from '@/pages/IQTools/Partials/IQToolMiddlePaneHeader/IQToolMiddlePaneHeader.vue';
import get from 'lodash/get';
import EditArea from '@/components/EditArea.vue';
import FileUploader from '@/components/FileUtil/FileUploader.vue';

export default {
  name: 'UploadForms',
  components: {
    IQToolMiddlePaneHeader,
    EditArea,
    FileUploader,
  },
  data() {
    return {
      baseTranslationPath: 'iq_tools_tab.forms_tab.upload',
      fileList: [],
    };
  },
  computed: {
    getTipContent() {
      let content = this.$t(`${this.baseTranslationPath}.upload_tip`);
      content = content.split('\n');
      content = content.map((item) => `<li>${item}</li>`);
      return `<ol>${content.join('')}</ol>`;
    },
  },
  methods: {
    async navigateAway() {
      // editor is contained by a route
      const id = get(this, '$route.params.id');
      if (id && this.$route.matched.length > 1) {
        // get the parent path
        const currentPath = this.$route.path;
        const parentPath = currentPath.substring(
          0,
          currentPath.lastIndexOf('/'),
        );
        // get parant name if exist
        const name = get(this.$route, 'meta.parentName');
        // move to the parent
        this.$router.push(name ? { name } : parentPath);
      }
    },
    getFileList(fileList) {
      this.fileList = fileList;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../../../styles/aiq-variables.scss";

:deep(ol), :deep(ul) {
    margin: unset;
    padding: unset;
    padding-left: 1.5rem;
}

:deep(ol li),
:deep(ul li) {
  margin: 0;
  padding: 5px 0;
}

:deep(ol li) {
  list-style: decimal;
}

:deep(ul li) {
  list-style: disc;
}
.edit-area {
  margin-top:30px;
}

.tip-header {
  display: flex;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  padding-bottom: 10px;
}
.tip-area {
  margin-top: 20px;
  font-size: 12px;
  font-weight: 400;
  padding: 10px;
  background-color: $aiq-bgc-list-item;
}
.uploader {
  padding: 30px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn {
  height: 40px;
  width: 70px;
}
.button-container {
  display: flex;
  gap: 5px;
  justify-content: flex-end;
}
</style>